import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export { addWalletConnectEvmExtension } from '../walletConnect/addWalletConnectEvmExtension';
export { connectAndVerifyWithWalletConnectEvm } from '../walletConnect/connectAndVerifyWithWalletConnectEvm';
export { connectWithWalletConnectEvm } from '../walletConnect/connectWithWalletConnectEvm';
export type { WalletConnectEvmWalletProvider } from '../walletConnect/walletConnectEvmWalletProvider.types';
